/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState } from "react";

import { useTextMessage } from '@fitinsur/hooks';

import { HasPermission } from "@fitinsur/components";
import { Layout } from "components";

import { PersonList } from "./lists/person";
import { AccessRoleList } from "./lists/accessRole";
import { AccessGroupList } from "./lists/accessGroup";
import { EconomicIndexersList } from "./lists/economicIndexers";
import { DocumentParamsList } from "./lists/document-params";
import Navigation from "./navigation";

export default function ManagementPage({ permissions, match, ...props }) {
  const { getDescription } = useTextMessage();

  const [currentList, setCurrentList] = useState();

  useEffect(() => {
   const paramsCurrentList = match.params.managementItem;

   if (paramsCurrentList === 'person' && permissions.MODULE_PERSON) {
     setCurrentList('person');
   } else if (paramsCurrentList === 'access-role' && permissions.MODULE_ACCESS_PROFILE) {
     setCurrentList('access-role');
   } else if (paramsCurrentList === 'access-group' && permissions.MODULE_ACCESS_GROUP) {
     setCurrentList('access-group');
   } else if (paramsCurrentList === 'economic-indexers' && permissions.EDIT_ECONOMIC_INDEXERS) {
    setCurrentList('economic-indexers');
   } else if (paramsCurrentList === 'document-params' && permissions.READ_DOCUMENT_PARAMETERS) {
    setCurrentList('document-params');
   }
  }, [permissions, match.params]);

  return (
    <Layout title={getDescription("DOMAINS", 777)} subtitle="">
      <Navigation permissions={permissions || {}} match={match || {}} setCurrentList={setCurrentList} currentList={currentList}/>

      <HasPermission permission={permissions.MODULE_PERSON && currentList === 'person'}>
        <PersonList permissions={permissions || {}} />
      </HasPermission>

      <HasPermission permission={permissions.MODULE_ACCESS_PROFILE && currentList === 'access-role'}>
        <AccessRoleList permissions={permissions || {}} />
      </HasPermission>

      <HasPermission permission={permissions.MODULE_ACCESS_GROUP && currentList === 'access-group'}>
        <AccessGroupList permissions={permissions || {}}/>
      </HasPermission>

      <HasPermission permission={permissions.EDIT_ECONOMIC_INDEXERS && currentList === 'economic-indexers'}>
        <EconomicIndexersList permissions={permissions || {}}/>
      </HasPermission>

      <HasPermission permission={permissions.READ_DOCUMENT_PARAMETERS && currentList === 'document-params'}>
        <DocumentParamsList permissions={permissions || {}} match={match || {}} />
      </HasPermission>
    </Layout >
  );
}
